import { render, staticRenderFns } from "./problemsModal.vue?vue&type=template&id=27b397cc&scoped=true&"
import script from "./problemsModal.vue?vue&type=script&lang=js&"
export * from "./problemsModal.vue?vue&type=script&lang=js&"
import style0 from "./problemsModal.vue?vue&type=style&index=0&id=27b397cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b397cc",
  null
  
)

export default component.exports